import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import useStyles from './adcard-styles';

function AdCard(props) {
  const classes = useStyles();
  const { source, redirect, className } = props;
  return (
    <div className={clsx(classes.root, className)}>
      <a href={redirect} target="_blank">
        <img src={source} alt="ads" className={classes.img} />
      </a>
    </div>
  );
}

AdCard.propTypes = {
  source: PropTypes.string.isRequired,
  redirect: PropTypes.string.isRequired,
  className: PropTypes.string,
};
AdCard.defaultProps = {
  className: '',
};

export default AdCard;
